export default __webpack_public_path__ + "fonts/NeueEinstellung-Regular.woff2";